module.exports = __webpack_public_path__ + "img/img10.c38d33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img10.jpg
// module id = 306
// module chunks = 0